import { render, staticRenderFns } from "./default.vue?vue&type=template&id=d5625bd8&"
import script from "./default.vue?vue&type=script&lang=ts&"
export * from "./default.vue?vue&type=script&lang=ts&"
import style0 from "./default.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "~/i18n/common.yaml?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fcodebuild%2Foutput%2Fsrc3657449903%2Fsrc%2Fthreease_pro%2Flayouts%2Fdefault.vue&lang=yaml"
if (typeof block0 === 'function') block0(component)
import block1 from "~/i18n/squareError.yaml?vue&type=custom&index=1&blockType=i18n&issuerPath=%2Fcodebuild%2Foutput%2Fsrc3657449903%2Fsrc%2Fthreease_pro%2Flayouts%2Fdefault.vue&lang=yaml"
if (typeof block1 === 'function') block1(component)
import block2 from "~/i18n/notificationMessages.yaml?vue&type=custom&index=2&blockType=i18n&issuerPath=%2Fcodebuild%2Foutput%2Fsrc3657449903%2Fsrc%2Fthreease_pro%2Flayouts%2Fdefault.vue&lang=yaml"
if (typeof block2 === 'function') block2(component)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {TheMobileBar: require('/codebuild/output/src3657449903/src/threease_pro/components/shared/TheMobileBar.vue').default,TheHeaderBar: require('/codebuild/output/src3657449903/src/threease_pro/components/shared/HeaderBar/TheHeaderBar.vue').default,TheHQSideBar: require('/codebuild/output/src3657449903/src/threease_pro/components/shared/SideBar/TheHQSideBar.vue').default,ClinicSettingSecondarySideBar: require('/codebuild/output/src3657449903/src/threease_pro/components/features/settingsCRMSideBar/ClinicSettingSecondarySideBar.vue').default,TheSideBar: require('/codebuild/output/src3657449903/src/threease_pro/components/shared/SideBar/TheSideBar.vue').default,TheConfirmWindow: require('/codebuild/output/src3657449903/src/threease_pro/components/shared/TheConfirmWindow.vue').default,TheSnackbar: require('/codebuild/output/src3657449903/src/threease_pro/components/shared/TheSnackbar.vue').default,ReportDownloadProgressSnackbar: require('/codebuild/output/src3657449903/src/threease_pro/components/shared/ReportDownloadProgressSnackbar.vue').default,TheChangelogModal: require('/codebuild/output/src3657449903/src/threease_pro/components/shared/TheChangelogModal.vue').default,TheGuideOverlay: require('/codebuild/output/src3657449903/src/threease_pro/components/shared/TheGuideOverlay.vue').default})


/* vuetify-loader */
import installComponents from "!../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
installComponents(component, {VApp})
